import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('./public/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },
  {
    path: 'master-data',
    loadChildren: () => import('./pages/master-data/master-data.module').then(m => m.MasterDataPageModule)
  },
  {
    path: 'days-sales-call-activity',
    loadChildren: () => import('./pages/days-sales-call-activity/days-sales-call-activity.module').then(m => m.DaysSalesCallActivityPageModule)
  },
  {
    path: 'sales-call-activity',
    loadChildren: () => import('./pages/sales-call-activity/sales-call-activity.module').then(m => m.SalesCallActivityPageModule)
  },
  {
    path: 'switch-language',
    loadChildren: () => import('./pages/switch-language/switch-language.module').then(m => m.SwitchLanguagePageModule)
  },
  {
    path: 'target-data',
    loadChildren: () => import('./pages/target-data/target-data.module').then(m => m.TargetDataPageModule)
  },
  {
    path: 'touch500',
    loadChildren: () => import('./pages/touch500/touch500.module').then(m => m.Touch500PageModule)
  },
  {
    path: 'touch500-activity',
    loadChildren: () => import('./pages/touch500-activity/touch500-activity.module').then(m => m.Touch500ActivityPageModule)
  },
  {
    path: 'activity-history',
    loadChildren: () => import('./pages/activity-history/activity-history.module').then(m => m.ActivityHistoryPageModule)
  },
  {
    path: 'landing',
    loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'indent-dashboard',
    loadChildren: () => import('./pages/indent-dashboard/indent-dashboard.module').then(m => m.IndentDashboardPageModule)
  },
  {
    path: 'create-indent',
    loadChildren: () => import('./pages/create-indent/create-indent.module').then(m => m.CreateIndentPageModule)
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },
  {
    path: 'cart-product-details',
    loadChildren: () => import('./pages/cart-product-details/cart-product-details.module').then(m => m.CartProductDetailsPageModule)
  },
  {
    path: 'info-indent',
    loadChildren: () => import('./pages/info-indent/info-indent.module').then(m => m.InfoIndentPageModule)
  },
  {
    path: 'update-indent',
    loadChildren: () => import('./pages/update-indent/update-indent.module').then(m => m.UpdateIndentPageModule)
  },
  {
    path: 'inventory-data',
    loadChildren: () => import('./pages/inventory-data/inventory-data.module').then(m => m.InventoryDataPageModule)
  },
  {
    path: 'credit-data',
    loadChildren: () => import('./pages/credit-data/credit-data.module').then(m => m.CreditDataPageModule)
  },
  {
    path: 'csp-data-allocation',
    loadChildren: () => import('./pages/csp-data-allocation/csp-data-allocation.module').then(m => m.CspDataAllocationPageModule)
  },
  {
    path: 'indent-reports',
    loadChildren: () => import('./pages/indent-reports/indent-reports.module').then(m => m.IndentReportsPageModule)
  },
  {
    path: 'realtime-dashboard',
    loadChildren: () => import('./pages/realtime-dashboard/realtime-dashboard.module').then(m => m.RealtimeDashboardPageModule)
  },
  {
    path: 'material-live-stock',
    loadChildren: () => import('./pages/material-live-stock/material-live-stock.module').then(m => m.MaterialLiveStockPageModule)
  },
  {
    path: 'touch500-master',
    loadChildren: () => import('./pages/touch500-master/touch500-master.module').then(m => m.Touch500MasterPageModule)
  },
  {
    path: 'touch500-sales-report',
    loadChildren: () => import('./pages/touch500-sales-report/touch500-sales-report.module').then(m => m.Touch500SalesReportPageModule)
  },
  {
    path: 'add-edit-golfcourse/:id',
    loadChildren: () => import('./pages/add-edit-golfcourse/add-edit-golfcourse.module').then(m => m.AddEditGolfcoursePageModule)
  },
  {
    path: 'sales-call-dashboard',
    loadChildren: () => import('./pages/sales-call-dashboard/sales-call-dashboard.module').then(m => m.SalesCallDashboardPageModule)
  },
  {
    path: 'landscape-remarks-upload',
    loadChildren: () => import('./pages/landscape-remarks-upload/landscape-remarks-upload.module').then(m => m.LandscapeRemarksUploadPageModule)
  }


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
